import Field from './Field';

const ReadonlyField = ({ label, value, action = null, size = 'default', className = '' }) => (
  <Field label={label} size={size} className={className}>
    <div className="field__control">
      <span className="field__value">{value}</span>
      {action}
    </div>
  </Field>
);

export default ReadonlyField;
